export const API_KEY = {
    // Electron APIs
    IPC_RENDERER: 'IPC_RENDERER',
    DESKTOP_CAPTURER: 'DESKTOP_CAPTURER',
    SYSTEM_PREFERENCES: 'SYSTEM_PREFERENCES',
    ANALYTICS: 'ANALYTICS',

    // Desktop APIs
    CAPTURE_SOURCE_PICKER: 'CAPTURE_SOURCE_PICKER',
    CHECK_SS_ACCESS_STATUS: 'CHECK_SS_ACCESS_STATUS',
    BORDERS_HALO: 'BORDERS_HALO',
    SHARING_BAR: 'SHARING_BAR',
    SET_APP_PID: 'SET_APP_PID',
    ANNOTATIONS_PAINTER: 'ANNOTATIONS_PAINTER',
    ANNOTATIONS_TRACKER: 'ANNOTATIONS_TRACKER',
    PERSISTENT_ANNOTATIONS: 'PERSISTENT_ANNOTATIONS',
    AVAILABLE_ML_LIBRARIES: 'AVAILABLE_ML_LIBRARIES',
    DESKTOP_LOG: 'DESKTOP_LOG',
    LOCALIZATION: 'LOCALIZATION',
    DESKTOP_CAPTURER_CONTROLLER: 'DESKTOP_CAPTURER_CONTROLLER',
    SET_FEATURE_FLAG_GETTER: 'SET_FEATURE_FLAG_GETTER',
    SET_LAUNCH_DARKLY_FLAGS: 'SET_LAUNCH_DARKLY_FLAGS',
    FORM_RC_DATA_FOR_EXTERNAL_CAPTURER: 'FORM_RC_DATA_FOR_EXTERNAL_CAPTURER',
    REMOTE_CONTROL: 'REMOTE_CONTROL',
    REACTIONS: 'REACTIONS',
    SET_OPTIMIZE_FOR_VIDEO: 'SET_OPTIMIZE_FOR_VIDEO',
    REACTIONS_2: 'REACTIONS_2',
    VIDEO_EFFECTS: 'VIDEO_EFFECTS',
    VIDEO_EFFECTS_2: 'VIDEO_EFFECTS_2',
    SHARE_MEDIA: 'SHARE_MEDIA',
    GET_RENDERER_KIT: 'GET_RENDERER_KIT',
    SET_OPTIMIZE_FOR_MULTIPLE_MONITORS: 'SET_OPTIMIZE_FOR_MULTIPLE_MONITORS',
    SET_FORCE_CAPTURER: 'SET_FORCE_CAPTURER',
};

export const FEATURE_KEY = {
    ANALYTICS: 'ANALYTICS',
    GREEN_HALO: 'GREEN_HALO',
    SHARING_BAR: 'SHARING_BAR',
    PICKER: 'PICKER',
    ELECTRON_IPC: 'ELECTRON_IPC',
    SHARING_PANEL: 'SHARING_PANEL',
    FULLSCREEN_NOTIFICATION: 'FULLSCREEN_NOTIFICATION',
    REMOTE_CONTROL: 'REMOTE_CONTROL',
    CHECK_SS_ACCESS_STATUS: 'CHECK_SS_ACCESS_STATUS',
    SYSTEM_PREFERENCES: 'SYSTEM_PREFERENCES',
    ANNOTATIONS_PAINTER: 'ANNOTATIONS_PAINTER',
    ANNOTATIONS_TRACKER: 'ANNOTATIONS_TRACKER',
    PERSISTENT_ANNOTATIONS: 'PERSISTENT_ANNOTATIONS',
    OPEN_IN_BROWSER: 'OPEN_IN_BROWSER',
    OPEN_IN_ELECTRON: 'OPEN_IN_ELECTRON',
    AVAILABLE_ML_LIBRARIES: 'AVAILABLE_ML_LIBRARIES',
    DESKTOP_LOG: 'DESKTOP_LOG',
    LOCALIZATION: 'LOCALIZATION',
    KRISP_AUTO_MODE: 'KRISP_AUTO_MODE',
    APM_KRISP_V9: 'APM_KRISP_V9',
    CUSTOM_ELECTRON_SHARING: 'CUSTOM_ELECTRON_SHARING',
    CAPTURER_ENFORCING: 'CAPTURER_ENFORCING',
    LAUNCH_DARKLY: 'LAUNCH_DARKLY',
    FEATURE_FLAGS: 'FEATURE_FLAGS',
    DATA_FOR_EXTERNAL_CAPTURER: 'DATA_FOR_EXTERNAL_CAPTURER',
    REACTIONS: 'REACTIONS',
    REACTIONS_2: 'REACTIONS_2',
    VIDEO_EFFECTS: 'VIDEO_EFFECTS',
    VIDEO_EFFECTS_2: 'VIDEO_EFFECTS_2',
    AEC_DUMP: 'AEC_DUMP',
    ADVANCED_AEC: 'ADVANCED_AEC',
    ADVANCED_AEC_EXACT: 'ADVANCED_AEC_EXACT',
    ECHO_LEAK_DETECTION: 'ECHO_LEAK_DETECTION',
    DSDK_API_2: 'DSDK_API_2',
    SHARE_MEDIA: 'SHARE_MEDIA',
    SHARING_0HZ: 'SHARING_0HZ',
    ECHO_LEAK_DETECTION_OPTIMIZATION: 'ECHO_LEAK_DETECTION_OPTIMIZATION',
    SCREEN_SHARE_DATA_TRACK: 'SCREEN_SHARE_DATA_TRACK',
    SET_OPTIMIZE_FOR_MULTIPLE_MONITORS: 'SET_OPTIMIZE_FOR_MULTIPLE_MONITORS',
    VP9_FLEXIBLE_MODE: 'VP9_FLEXIBLE_MODE',
};

export const APIS = {
    [API_KEY.IPC_RENDERER]: {
        name: 'ipcRenderer',
        path: ['_electronAPI', 'ipcRenderer'],
    },

    [API_KEY.DESKTOP_CAPTURER]: {
        name: 'desktopCapturer',
        path: ['_electronAPI', 'desktopCapturer'],
    },

    [API_KEY.SYSTEM_PREFERENCES]: {
        name: 'systemPreferences',
        path: ['_electronAPI', 'systemPreferences'],
    },

    [API_KEY.DESKTOP_LOG]: {
        name: 'desktopLog',
        path: ['_electronAPI', 'desktopLog'],
    },

    [API_KEY.ANALYTICS]: {
        name: 'Analytics',
        path: ['_loadedDeps', 'rcv-desktop-tools', 'M', 'RCVAnalytics'],
    },

    [API_KEY.CAPTURE_SOURCE_PICKER]: {
        name: 'CaptureSourcePicker',
        path: ['_loadedDeps', 'rcv-desktop-tools', 'P', 'CaptureSourcePicker'],
    },

    [API_KEY.CHECK_SS_ACCESS_STATUS]: {
        name: 'getScreenRecordingAccessStatus',
        path: ['_loadedDeps', 'rcv-desktop-tools', 'P', 'getScreenRecordingAccessStatus'],
    },

    [API_KEY.BORDERS_HALO]: {
        name: 'BordersHalo',
        path: ['_loadedDeps', 'rcv-desktop-tools', 'P', 'BordersHalo'],
    },

    [API_KEY.SHARING_BAR]: {
        name: 'SharingBar',
        path: ['_loadedDeps', 'rcv-desktop-tools', 'P', 'SharingBar'],
    },

    [API_KEY.SET_APP_PID]: {
        name: 'setAppPid',
        path: ['_loadedDeps', 'rcv-desktop-tools', 'M', 'setAppPid'],
    },
    [API_KEY.ANNOTATIONS_PAINTER]: {
        name: 'AnnotationsPainter',
        path: ['_loadedDeps', 'rcv-desktop-tools', 'P', 'AnnotationsPainter'],
    },

    [API_KEY.ANNOTATIONS_TRACKER]: {
        name: 'AnnotationsTracker',
        path: ['_loadedDeps', 'rcv-desktop-tools', 'P', 'AnnotationsTracker'],
    },
    [API_KEY.AVAILABLE_ML_LIBRARIES]: {
        name: 'getAvailableMLLibraries',
        path: ['_loadedDeps', 'rcv-desktop-tools', 'M', 'getAvailableMLLibraries'],
    },
    [API_KEY.DESKTOP_CAPTURER_CONTROLLER]: {
        name: 'rcDesktopCapturerController',
        path: ['_electronAPI', 'rcDesktopCapturerController'],
    },
    [API_KEY.SET_LAUNCH_DARKLY_FLAGS]: {
        name: 'setLaunchDarklyFlags',
        path: ['_electronAPI', 'setLaunchDarklyFlags'],
    },
    [API_KEY.SET_FEATURE_FLAG_GETTER]: {
        name: 'setFeatureFlagGetter',
        path: ['_electronAPI', 'setFeatureFlagGetter'],
    },
    [API_KEY.FORM_RC_DATA_FOR_EXTERNAL_CAPTURER]: {
        name: 'formRcDataForExternalCapturer',
        path: ['_electronAPI', 'formRcDataForExternalCapturer'],
    },
    [API_KEY.REMOTE_CONTROL]: {
        name: 'RemoteControl',
        path: ['_loadedDeps', 'rcv-desktop-tools', 'P', 'RemoteControl'],
    },
    [API_KEY.VIDEO_EFFECTS]: {
        name: 'VideoEffects',
        path: ['_loadedDeps', 'rcv-desktop-tools/native-vbg-api'],
    },
    [API_KEY.VIDEO_EFFECTS_2]: {
        name: 'VideoEffects2',
        path: ['_electronAPI', 'getNativeVideoProcessingAPI'],
    },
    [API_KEY.SET_OPTIMIZE_FOR_VIDEO]: {
        name: 'setOptimizeForVideo',
        path: ['_electronAPI', 'setOptimizeForVideo'],
    },
    [API_KEY.SHARE_MEDIA]: {
        name: 'addShareMediaAPI',
        path: ['_electronAPI', 'addShareMediaAPI'],
    },
    [API_KEY.GET_RENDERER_KIT]: {
        name: 'getRendererKIT',
        path: ['_electronAPI', 'getKIT'],
    },
    [API_KEY.SET_OPTIMIZE_FOR_MULTIPLE_MONITORS]: {
        name: 'setOptimizeForMultipleMonitors',
        path: ['_electronAPI', 'setOptimizeForMultipleMonitors'],
    },
    [API_KEY.SET_FORCE_CAPTURER]: {
        name: 'setForceCapturer',
        path: ['_electronAPI', 'setForceCapturer'],
    },
};

/**
 * @typedef FeatureDeclaration
 * @property { String }     name - used only for info messages
 * @property { API_KEY[] }  requiredApis - electron APIs, necessary for the feature
 * @property { String }     [webConfigPlatformsKey] - corresponding key in app.config.js
 *                          Absence implies no dependency on app.config.json
 * @property { String }     [electronFeatureSetKey] - corresponding key in electron feature set object from electron
 *                          Absence implies no dependency on feature set
 */

/**
 * @type { Object.<FEATURE_KEY, FeatureDeclaration> }
 */
export const FEATURES = {
    [FEATURE_KEY.ANALYTICS]: {
        name: 'Analytics',
        requiredApis: [API_KEY.ANALYTICS],
        webConfigPlatformsKey: 'analyticsPlatforms',
        electronFeatureSetKey: 'analytics',
    },
    [FEATURE_KEY.PICKER]: {
        name: 'Advanced screen sharing source picker',
        requiredApis: [API_KEY.CAPTURE_SOURCE_PICKER, API_KEY.SET_APP_PID],
        webConfigPlatformsKey: 'pickerPlatforms',
        electronFeatureSetKey: 'picker',
    },
    [FEATURE_KEY.GREEN_HALO]: {
        name: 'Green halo',
        requiredApis: [API_KEY.BORDERS_HALO],
        webConfigPlatformsKey: 'greenHaloPlatforms',
        electronFeatureSetKey: 'green_halo',
    },
    [FEATURE_KEY.SHARING_BAR]: {
        name: 'Screen sharing toolbar',
        requiredApis: [API_KEY.SHARING_BAR],
        webConfigPlatformsKey: 'sharingBarPlatforms',
        electronFeatureSetKey: 'sharing_bar',
    },
    [FEATURE_KEY.REMOTE_CONTROL]: {
        name: 'Remote control',
        requiredApis: [API_KEY.REMOTE_CONTROL],
        webConfigPlatformsKey: 'remoteControlPlatforms',
        electronFeatureSetKey: 'remote_control',
    },
    [FEATURE_KEY.SHARING_PANEL]: {
        name: 'Sharing panel',
        requiredApis: [API_KEY.IPC_RENDERER],
        webConfigPlatformsKey: 'sharingPanelPlatforms',
        electronFeatureSetKey: 'floating_panel',
    },
    [FEATURE_KEY.FULLSCREEN_NOTIFICATION]: {
        name: 'Fullscreen notification',
        requiredApis: [API_KEY.IPC_RENDERER],
        webConfigPlatformsKey: 'fullscreenNotificationPlatforms',
        electronFeatureSetKey: 'esc_tooltip',
    },
    [FEATURE_KEY.CHECK_SS_ACCESS_STATUS]: {
        name: 'SS access status checker',
        requiredApis: [API_KEY.CHECK_SS_ACCESS_STATUS],
    },
    [FEATURE_KEY.ELECTRON_IPC]: {
        name: 'Electron IPC',
        requiredApis: [API_KEY.IPC_RENDERER],
    },
    [FEATURE_KEY.SYSTEM_PREFERENCES]: {
        name: 'System preferences',
        requiredApis: [API_KEY.SYSTEM_PREFERENCES],
    },
    [FEATURE_KEY.ANNOTATIONS_PAINTER]: {
        name: 'Annotations painter',
        requiredApis: [API_KEY.ANNOTATIONS_PAINTER],
        webConfigPlatformsKey: 'annotationsPainterPlatforms',
        electronFeatureSetKey: 'annotations_painter',
    },
    [FEATURE_KEY.ANNOTATIONS_TRACKER]: {
        name: 'Annotations tracker',
        requiredApis: [API_KEY.ANNOTATIONS_TRACKER],
        webConfigPlatformsKey: 'annotationsTrackerPlatforms',
        electronFeatureSetKey: 'annotations_tracker',
    },
    [FEATURE_KEY.PERSISTENT_ANNOTATIONS]: {
        name: 'Persistent annotations',
        requiredApis: [API_KEY.IPC_RENDERER],
        electronFeatureSetKey: 'persistent_annotations',
    },
    [FEATURE_KEY.OPEN_IN_BROWSER]: {
        name: 'Open url in browser',
        requiredApis: [API_KEY.IPC_RENDERER],
        electronFeatureSetKey: 'open_in_browser',
    },
    [FEATURE_KEY.OPEN_IN_ELECTRON]: {
        name: 'Open url in electron window',
        requiredApis: [API_KEY.IPC_RENDERER],
        electronFeatureSetKey: 'open_in_electron',
    },
    [FEATURE_KEY.AVAILABLE_ML_LIBRARIES]: {
        name: 'Get available ML Libraries',
        requiredApis: [API_KEY.AVAILABLE_ML_LIBRARIES],
    },
    [FEATURE_KEY.DESKTOP_LOG]: {
        name: 'Logging via RCV Desktop SDK',
        requiredApis: [API_KEY.DESKTOP_LOG],
    },
    [FEATURE_KEY.LOCALIZATION]: {
        name: 'Localization',
        requiredApis: [API_KEY.IPC_RENDERER],
        electronFeatureSetKey: 'localization',
    },
    [FEATURE_KEY.KRISP_AUTO_MODE]: {
        name: 'Krisp denoiser auto mode',
        requiredApis: [],
        electronFeatureSetKey: 'krisp_auto_mode',
    },
    [FEATURE_KEY.APM_KRISP_V9]: {
        name: 'APM Krisp v9 support',
        requiredApis: [],
    },
    [FEATURE_KEY.CUSTOM_ELECTRON_SHARING]: {
        name: 'Custom Electron Sharing',
        requiredApis: [API_KEY.DESKTOP_CAPTURER_CONTROLLER],
    },
    [FEATURE_KEY.CAPTURER_ENFORCING]: {
        name: 'Desktop capturer enforcing',
        requiredApis: [API_KEY.DESKTOP_CAPTURER_CONTROLLER],
        electronFeatureSetKey: 'capturer_enforcing',
    },
    [FEATURE_KEY.LAUNCH_DARKLY]: {
        name: 'Desktop Launch Darkly API',
        requiredApis: [API_KEY.SET_LAUNCH_DARKLY_FLAGS],
        electronFeatureSetKey: 'launch_darkly',
    },
    [FEATURE_KEY.FEATURE_FLAGS]: {
        name: 'Provide desktop app with feature-flags',
        requiredApis: [API_KEY.SET_FEATURE_FLAG_GETTER],
    },
    [FEATURE_KEY.DATA_FOR_EXTERNAL_CAPTURER]: {
        name: 'Form RC Data For External Capturer',
        requiredApis: [API_KEY.FORM_RC_DATA_FOR_EXTERNAL_CAPTURER],
    },
    [FEATURE_KEY.REACTIONS]: {
        name: 'reactions',
        requiredApis: [API_KEY.SHARING_BAR],
        electronFeatureSetKey: 'reactions',
    },
    [FEATURE_KEY.REACTIONS_2]: {
        name: 'reactions with slow and fast feedback support',
        requiredApis: [API_KEY.SHARING_BAR],
        electronFeatureSetKey: 'reactions_2',
    },
    [FEATURE_KEY.VIDEO_EFFECTS]: {
        name: 'Native video processing (worker)',
        requiredApis: [API_KEY.VIDEO_EFFECTS],
        electronFeatureSetKey: 'native_vbg',
    },
    [FEATURE_KEY.VIDEO_EFFECTS_2]: {
        name: 'Native video processing (GUM)',
        requiredApis: [API_KEY.VIDEO_EFFECTS_2],
        electronFeatureSetKey: 'native_vbg',
    },
    [FEATURE_KEY.AEC_DUMP]: {
        name: 'AEC dump generation',
        requiredApis: [API_KEY.IPC_RENDERER],
        electronFeatureSetKey: 'aec_dump',
    },
    [FEATURE_KEY.ADVANCED_AEC]: {
        name: 'Advanced AEC by RC',
        requiredApis: [],
        electronFeatureSetKey: 'advanced_aec',
    },
    [FEATURE_KEY.ADVANCED_AEC_EXACT]: {
        name: 'Advanced AEC with exact constraint',
        requiredApis: [],
        electronFeatureSetKey: 'rcv_112671_exact_aaec_config_constraints_support',
    },
    [FEATURE_KEY.ECHO_LEAK_DETECTION]: {
        name: 'Echo leak detection',
        requiredApis: [],
        electronFeatureSetKey: 'echo_leak_detection',
    },
    [FEATURE_KEY.DSDK_API_2]: {
        name: 'DSDK Api v2',
        requiredApis: [],
    },
    [FEATURE_KEY.SHARE_MEDIA]: {
        name: 'Share Computer Audio',
        requiredApis: [API_KEY.SHARE_MEDIA],
        electronFeatureSetKey: 'computer_audio_sharing',
    },
    [FEATURE_KEY.SHARING_0HZ]: {
        name: 'Screen Sharing 0hz',
        requiredApis: [],
        electronFeatureSetKey: 'screen_sharing_0hz',
    },
    [FEATURE_KEY.ECHO_LEAK_DETECTION_OPTIMIZATION]: {
        name: 'Echo leak detection optimization',
        requiredApis: [],
        electronFeatureSetKey: 'echo_leak_detection_optimization_rcv_108144',
    },
    [FEATURE_KEY.SCREEN_SHARE_DATA_TRACK]: {
        name: 'Screen Share Data Track',
        requiredApis: [],
        electronFeatureSetKey: 'screen_share_data_track',
    },
    [FEATURE_KEY.SET_OPTIMIZE_FOR_MULTIPLE_MONITORS]: {
        name: 'Set optimize for multiple monitors',
        requiredApis: [API_KEY.SET_OPTIMIZE_FOR_MULTIPLE_MONITORS],
    },
    [FEATURE_KEY.VP9_FLEXIBLE_MODE]: {
        name: 'VP9 codec flexible mode',
        requiredApis: [],
    },
};

export const DESKTOP_ANALYTICS_EVENTS = {
    CLIENT_INFO: 'clientInfo',
    UTILIZATION: 'utilization',
} as const;
